import { Lightbulb } from 'lucide-react';

const QUESTIONS = [
  "What's the optimal price point for maximizing profit?",
  "Which features should I cut to improve P&L at $999?",
  "Explain the two distinct buyer groups",
  "How many S1 leads do I need to break even at $1,499?",
  "Compare a tiered vs single-price strategy",
  "What do the most engaged respondents say about their health goals?",
  "Which features do people say are important but don't actually choose?",
  "How does each segment respond to my three configured packages?",
];

interface SuggestedQuestionsProps {
  onSelect: (question: string) => void;
}

export function SuggestedQuestions({ onSelect }: SuggestedQuestionsProps) {
  return (
    <div className="flex-1 flex flex-col items-center justify-start md:justify-center px-6 py-4 md:py-8 overflow-y-auto min-h-0">
      <div className="w-10 h-10 md:w-12 md:h-12 rounded-2xl flex items-center justify-center bg-chart-teal/10 mb-2 md:mb-4 shrink-0">
        <Lightbulb size={20} className="text-chart-teal md:hidden" />
        <Lightbulb size={22} className="text-chart-teal hidden md:block" />
      </div>
      <h3 className="text-sm font-semibold text-primary mb-0.5 md:mb-1 shrink-0">Ask the AI Analyst</h3>
      <p className="text-xs text-muted mb-3 md:mb-6 text-center max-w-xs shrink-0">
        I have full access to the conjoint study data and your current simulator configuration.
      </p>
      <div className="space-y-1.5 md:space-y-2 w-full max-w-sm">
        {QUESTIONS.map(q => (
          <button
            key={q}
            onClick={() => onSelect(q)}
            className="w-full text-left text-xs px-3 py-2 md:py-2.5 rounded-lg transition-all text-secondary hover:text-primary border"
            style={{ borderColor: 'var(--color-border)' }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = 'var(--color-hover-bg)')}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = '')}
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
